import { useCallback } from 'react';
import { identityApiRef, useApi, useApiHolder } from '@backstage/core-plugin-api';
import { SidebarItem, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { manewcoTokens, signOutHooksApiRef } from '@platform/plugin-platform-react';

const useStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      margin: '0 16px 12px',
      padding: '6px 10px',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      fontSize: 12,
      color: MANEWCO.textSecondary,
      '&:hover': { color: MANEWCO.primary },
    },
  };
});

/**
 * Déconnexion de l'application : exécute d'abord les crochets du socle
 * (fermeture des sessions Keycloak et GitLab), puis `identityApi.signOut()`.
 * Un crochet en échec ou l'absence de l'API des crochets n'empêchent jamais
 * la déconnexion.
 */
export const SignOutButton = () => {
  const classes = useStyles();
  const identityApi = useApi(identityApiRef);
  const hooks = useApiHolder().get(signOutHooksApiRef);
  const { isOpen } = useSidebarOpenState();

  const signOut = useCallback(async () => {
    try {
      await hooks?.runAll();
    } catch {
      // la déconnexion continue
    }
    await identityApi.signOut();
  }, [hooks, identityApi]);

  if (!isOpen) return <SidebarItem icon={ExitToAppIcon} text="Se déconnecter" onClick={signOut} />;
  return (
    <button type="button" className={classes.button} onClick={signOut}>
      <ExitToAppIcon fontSize="small" aria-hidden />
      Se déconnecter
    </button>
  );
};
